import { IconName } from '@ardoq/icons';
import { pluralize } from '@ardoq/common-helpers';
import { addComponentsToScenario } from './actionWrappers';
import { MAIN_NODE_ID } from './consts';
import { trackClickStartAddToScenario } from 'scope/tracking';
import type { ArdoqId } from '@ardoq/api-types';
import { getScopeComponents } from 'loadedScenarioData';
import { DropdownOptionType } from '@ardoq/dropdown-menu';
import {
  ContextMenuData,
  ContextMenuListener,
  getDataContextId,
} from '@ardoq/context-menu';

const getComponentIdsToInclude = (
  selectedIds: ArdoqId[],
  targetComponentId: ArdoqId | null
): ArdoqId[] => {
  const selectedComponentIds = selectedIds.filter(id => id !== MAIN_NODE_ID);
  if (!targetComponentId || selectedComponentIds.includes(targetComponentId)) {
    return selectedComponentIds;
  }
  return [targetComponentId];
};

export const getScenarioRelatedContextMenuData = (
  selectedIds: ArdoqId[],
  targetComponentId: ArdoqId | null
): ContextMenuData => {
  const componentIds = getComponentIdsToInclude(selectedIds, targetComponentId);
  if (componentIds.length === 0) {
    return { options: null };
  }

  return {
    options: [
      {
        name: `add-component`,
        label: `Include ${componentIds.length} ${pluralize(
          'component',
          componentIds.length
        )}`,
        iconName: IconName.ADD,
        onClick: () => {
          addComponentsToScenario(componentIds);
          trackClickStartAddToScenario('relatedNavigator');
        },
        type: DropdownOptionType.BUTTON_OPTION,
      },
    ],
  };
};

export const scenarioRelatedContextMenuName = 'scenario-related-context-menu';

export const createScenarioRelatedContextMenu = (
  selectedIds: ArdoqId[]
): ContextMenuListener => ({
  getContextMenuData: ({ target }) =>
    getScenarioRelatedContextMenuData(
      selectedIds,
      getDataContextId('data-component-id')(target)
    ),
});

export const allComponentsInScopeAreSelected = (componentsIds: ArdoqId[]) =>
  getScopeComponents().every(componentId =>
    componentsIds.includes(componentId)
  );
